<template>
    <div>
        <x-checkbox
            :id="`show-checked_${localThemelayer.id}`"
            :name="`show-checked_${localThemelayer.id}`"
            class="mb-2"
            :text="$t('showCheckedForEasierSorting')"
            v-model="showCheckedItemsOnly"
        >
        </x-checkbox>
        <div class="table-sticky-header-container">
            <div>
                <table
                    id="informationoverview"
                    class="table table-striped table-responsive table-bordered"
                >
                    <!-- SonarQube staat er op dat een <caption> wordt toegevoegd -->
                    <caption v-if="false">
                        Thema details
                    </caption>
                    <thead>
                        <tr class="tablerow">
                            <th
                                scope="col"
                                class="borderless-header"
                                v-for="item in computedFields"
                                :key="item.key"
                            >
                                {{ item.label }}
                            </th>
                        </tr>
                        <!-- Checkboxes in header are not draggable -->
                        <tr>
                            <td colspan="4">
                                <b-button
                                    :title="$t('changeOrder')"
                                    @click="$_onClickChangeOrder"
                                    class="mr-2"
                                >
                                    <em
                                        class="fa fa-sort-numeric-down pt-1"
                                    ></em>
                                </b-button>
                                <b-button
                                    :title="$t('putCheckedOnTop')"
                                    @click="$_onClickMoveCheckedOnTop"
                                >
                                    <em class="fa fa-tasks pt-1"></em>
                                </b-button>
                            </td>
                            <td class="text-center">
                                <x-checkbox
                                    :id="`displayInTableAll_${localThemelayer.id}`"
                                    :name="`displayInTableAll_${localThemelayer.id}`"
                                    :state="null"
                                    :plainMode="true"
                                    :value="allDisplayInTableChecked"
                                    @input="
                                        $_onDisplayInTableAll(
                                            localThemelayer,
                                            $event
                                        )
                                    "
                                    :indeterminate="displayInTableIntermediate"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center">
                                <x-checkbox
                                    :id="`displayInDetailAll_${localThemelayer.id}`"
                                    :name="`displayInDetailAll_${localThemelayer.id}`"
                                    :state="null"
                                    :plainMode="true"
                                    :value="allDisplayInDetailChecked"
                                    @input="
                                        $_onDisplayInDetailAll(
                                            localThemelayer,
                                            $event
                                        )
                                    "
                                    :indeterminate="displayInDetailIntermediate"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center">
                                <x-checkbox
                                    :id="`popupAll_${localThemelayer.id}`"
                                    :name="`popupAll_${localThemelayer.id}`"
                                    :state="null"
                                    :plainMode="true"
                                    :value="allPopupChecked"
                                    @input="
                                        $_onPopupAll(localThemelayer, $event)
                                    "
                                    :indeterminate="popupIntermediate"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td
                                v-show="localThemelayer.exportable === true"
                                class="text-center"
                            >
                                <x-checkbox
                                    :id="`exportAll_${localThemelayer.id}`"
                                    :name="`exportAll_${localThemelayer.id}`"
                                    :state="null"
                                    :plainMode="true"
                                    :disabled="
                                        localThemelayer.exportable === false
                                    "
                                    :value="allExportableChecked"
                                    @input="
                                        $_onExportAll(localThemelayer, $event)
                                    "
                                    :indeterminate="exportableIntermediate"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td
                                v-show="localThemelayer.print === true"
                                class="text-center"
                            >
                                <x-checkbox
                                    :id="`printAll_${localThemelayer.id}`"
                                    :name="`printAll_${localThemelayer.id}`"
                                    :state="null"
                                    :plainMode="true"
                                    :disabled="localThemelayer.print === false"
                                    :value="allPrintChecked"
                                    @input="
                                        $_onPrintAll(localThemelayer, $event)
                                    "
                                    :indeterminate="printIntermediate"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td colspan="7"></td>
                        </tr>
                    </thead>
                    <v-draggable
                        tag="tbody"
                        handle=".fa-arrows-alt"
                        v-model="localThemelayer.informationAttributes"
                        @end="$_updateOrderColumn"
                    >
                        <tr
                            v-for="item in localThemelayer.informationAttributes"
                            :key="item.name"
                            class="tablerow"
                            v-show="showTableRow(item)"
                        >
                            <td class="order-column">
                                <div>
                                    <em class="fa fa-arrows-alt"></em>
                                    <base-input
                                        type="text"
                                        :id="`${item.attribute}_order`"
                                        v-model="item.order"
                                        extendedClass="order-input"
                                    >
                                    </base-input>
                                </div>
                            </td>
                            <td class="align-middle">
                                <span>{{ item.attribute }}</span>
                            </td>
                            <td>
                                <base-input
                                    type="text"
                                    :id="`${item.attribute}_alias`"
                                    v-model="item.alias"
                                    :extendedStyle="'width: auto'"
                                >
                                </base-input>
                            </td>
                            <td>
                                <x-select
                                    :id="`${item.attribute}_sort`"
                                    v-model="item.sort"
                                    :options="sortOptions"
                                    :simpleMode="true"
                                    extendedClass="sort-select"
                                >
                                </x-select>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_displayInTable`"
                                    :name="`${item.attribute}_displayInTable`"
                                    :state="null"
                                    :plainMode="true"
                                    @input="
                                        $_onInputDisplayInTable(
                                            localThemelayer,
                                            item,
                                            displayType.table
                                        )
                                    "
                                    v-model="item.displayInTable"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_displayInDetail`"
                                    :name="`${item.attribute}_displayInDetail`"
                                    :state="null"
                                    :plainMode="true"
                                    @input="
                                        $_updateIntermediateState(
                                            localThemelayer,
                                            displayType.detail
                                        )
                                    "
                                    v-model="item.displayInDetail"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_popup`"
                                    :name="`${item.attribute}_popup`"
                                    :state="null"
                                    :plainMode="true"
                                    @input="
                                        $_updateIntermediateState(
                                            localThemelayer,
                                            displayType.popup
                                        )
                                    "
                                    v-model="item.popup"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td
                                v-show="localThemelayer.exportable === true"
                                class="text-center align-middle"
                            >
                                <x-checkbox
                                    :id="`${item.attribute}_export`"
                                    :name="`${item.attribute}_export`"
                                    :state="null"
                                    :plainMode="true"
                                    :disabled="
                                        localThemelayer.exportable === false
                                    "
                                    @input="
                                        $_updateIntermediateState(
                                            localThemelayer,
                                            displayType.exportable
                                        )
                                    "
                                    v-model="item.exportable"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td
                                v-show="localThemelayer.print === true"
                                class="text-center align-middle"
                            >
                                <x-checkbox
                                    :id="`${item.attribute}_print`"
                                    :name="`${item.attribute}_print`"
                                    :state="null"
                                    :plainMode="true"
                                    :disabled="localThemelayer.print === false"
                                    @input="
                                        $_updateIntermediateState(
                                            localThemelayer,
                                            displayType.print
                                        )
                                    "
                                    v-model="item.print"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td
                                v-show="localThemelayer.harvest === true"
                                class="text-center align-middle"
                            >
                                <x-checkbox
                                    :id="`${item.attribute}_harvest`"
                                    :name="`${item.attribute}_harvest`"
                                    :state="null"
                                    :plainMode="true"
                                    @change="$_harvestNotification($event)"
                                    v-model="item.harvest"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_hyperlink`"
                                    :name="`${item.attribute}_hyperlink`"
                                    :state="null"
                                    :plainMode="true"
                                    v-model="item.hyperlink"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <base-input
                                    type="text"
                                    :id="`${item.attribute}_hyperlinkText`"
                                    v-show="item.hyperlink"
                                    v-model="item.hyperlinkText"
                                    maxlength="255"
                                >
                                </base-input>
                            </td>
                            <td class="text-center align-middle">
                                <base-input
                                    type="text"
                                    :id="`${item.attribute}_hyperlinkExpression`"
                                    v-show="item.hyperlink"
                                    v-model="item.hyperlinkExpression"
                                    maxlength="255"
                                >
                                </base-input>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_openExtern`"
                                    :name="`${item.attribute}_openExtern`"
                                    :state="null"
                                    :plainMode="true"
                                    v-show="item.hyperlink"
                                    v-model="item.openExtern"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox
                                    :id="`${item.attribute}_hyperlinkImage`"
                                    :name="`${item.attribute}_hyperlinkImage`"
                                    :state="null"
                                    :plainMode="true"
                                    v-show="item.hyperlink"
                                    v-model="item.hyperlinkImage"
                                    :expandClickArea="true"
                                >
                                </x-checkbox>
                            </td>
                            <td class="text-center align-middle">
                                <b-button
                                    v-bind:id="`${item.attribute}_removeAttribute`"
                                    v-bind:name="`${item.attribute}_removeAttribute`"
                                    v-show="item.unavailable"
                                    @click="$_removeAttribute(item)"
                                >
                                    <span class="fa fa-trash-alt"></span>
                                </b-button>
                            </td>
                        </tr>
                    </v-draggable>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import XCheckbox from '../../BaseComponents/x-checkbox.vue';
    import XSelect from '../../BaseComponents/x-select.vue';
    import BaseInput from '../../BaseComponents/base-input.vue';
    import modalMixin from '../../Mixins/ModalMixin.vue';
    import { without } from 'lodash';
    import { SORT_ORDER } from '../../../constants';

    export default {
        name: 'InformationTab',
        mixins: [modalMixin],

        components: {
            'v-draggable': draggable,
            'x-checkbox': XCheckbox,
            'x-select': XSelect,
            'base-input': BaseInput
        },

        props: {
            themelayer: { type: Object }
        },

        data() {
            return {
                fields: [
                    {
                        key: 'order',
                        label: this.$t('changeLayerOrder')
                    },
                    {
                        key: 'attribute',
                        label: this.$t('labelAttributeName')
                    },
                    {
                        key: 'alias',
                        label: 'Label'
                    },
                    {
                        key: 'sort',
                        label: this.$t('sort')
                    },
                    {
                        key: 'displayInTable',
                        label: 'Tabel weergave'
                    },
                    {
                        key: 'displayInDetail',
                        label: 'Detail weergave'
                    },
                    {
                        key: 'popup',
                        label: 'Eén venster weergave'
                    },
                    {
                        key: 'export',
                        label: this.$t('labelExportable'),
                        showExportColumn: false
                    },
                    {
                        key: 'print',
                        label: this.$t('labelPrint'),
                        showPrintColumn: false
                    },
                    {
                        key: 'harvest',
                        label: 'Zoekeigenschap',
                        showHarvestColumn: false
                    },
                    {
                        key: 'hyperlink',
                        label: 'Bevat hyperlink'
                    },
                    {
                        key: 'hyperlinkText',
                        label: 'Hyperlink tekst'
                    },
                    {
                        key: 'hyperlinkExpression',
                        label: 'Hyperlink expressie'
                    },
                    {
                        key: 'openExtern',
                        label: 'Hyperlink extern openen'
                    },
                    {
                        key: 'hyperlinkImage',
                        label: 'Hyperlink is image'
                    },
                    {
                        key: 'removeAttribute',
                        label: '',
                        class: 'text-right'
                    }
                ],
                displayType: {
                    table: 'displayInTable',
                    detail: 'displayInDetail',
                    popup: 'popup',
                    exportable: 'exportable',
                    print: 'print'
                },
                sortOptions: [
                    {
                        value: SORT_ORDER.ASCENDING,
                        text: this.$t('sortAscending')
                    },
                    {
                        value: SORT_ORDER.DESCENDING,
                        text: this.$t('sortDescending')
                    }
                ],
                displayInTableIntermediate: false,
                displayInDetailIntermediate: false,
                popupIntermediate: false,
                allDisplayInTableChecked: false,
                allDisplayInDetailChecked: false,
                allPopupChecked: false,
                allExportableChecked: false,
                allPrintChecked: false,
                exportableIntermediate: false,
                printIntermediate: false,
                showCheckedItemsOnly: false,
                // use a local variable, so eslint doesnt complain
                // deep copy isnt possible, the structure of informationAttributes is
                // used in AdvancedLabelsTab too
                localThemelayer: this.themelayer
            };
        },

        mounted() {
            this.$_setIndeterminateStates();
            this.$_updateOrderColumn();
        },

        computed: {
            computedFields() {
                let filteredFields = this.fields;
                if (this.localThemelayer.print === false) {
                    filteredFields = filteredFields.filter(
                        (field) => field.showPrintColumn !== false
                    );
                }
                if (this.localThemelayer.exportable === false) {
                    filteredFields = filteredFields.filter(
                        (field) => field.showExportColumn !== false
                    );
                }
                if (this.localThemelayer.harvest === false) {
                    filteredFields = filteredFields.filter(
                        (field) => field.showHarvestColumn !== false
                    );
                }
                return filteredFields;
            },
            showTableRow() {
                return (item) => {
                    return this.showCheckedItemsOnly
                        ? item.displayInDetail || item.displayInTable || item.popup
                        : true;
                };
            }
        },

        methods: {
            /**
             * Returns true if all informationAttributes are marked as checked
             * @param themelayer
             * @param displayType
             */
            $_getAllCheckedState(themelayer, displayType) {
                return themelayer.informationAttributes.every(
                    (ia) => ia[displayType]
                );
            },

            /**
             * Returns the intermediate state
             * @param themelayer
             * @param displayType
             */
            $_getIntermediateState(themelayer, displayType) {
                return (
                    themelayer.informationAttributes.some(
                        (ia) => ia[displayType]
                    ) && !this.$_getAllCheckedState(themelayer, displayType)
                );
            },

            /**
             * Shows a info message when a new attribute is chosen for searchterm harvesting/searchType.
             * @param {bool} isHarvested the new boolean value indicating that the attribute is being harvested
             */
            $_harvestNotification(isHarvested) {
                if (isHarvested) {
                    const data = { message: this.$t('harvestMsg') };
                    this.showToast(data);
                }
            },

            /**
             * Sets the property displayInDetail of all informationAttributes
             * @param themelayer the active themelayer
             * @param value the value of checkbox, true is Checked and false is Unchecked
             */
            $_onDisplayInDetailAll(themelayer, value) {
                themelayer.informationAttributes.forEach(
                    (item) => (item.displayInDetail = value)
                );
            },

            /**
             * Sets the property displayInTable of all informationAttributes
             * @param themelayer the active themelayer
             * @param value the value of checkbox, true is Checked and false is Unchecked
             */
            $_onDisplayInTableAll(themelayer, value) {
                themelayer.informationAttributes.forEach(
                    (item) => (item.displayInTable = value)
                );
            },

            /**
             * Sets the property popup of all informationAttributes
             * @param themelayer the active themelayer
             * @param value the value of checkbox, true is Checked and false is Unchecked
             */
            $_onPopupAll(themelayer, value) {
                themelayer.informationAttributes.forEach(
                    (item) => (item.popup = value)
                );
            },

            /**
             * Sets the property exportable of all informationAttributes
             * @param themelayer the active themelayer
             * @param value the value of checkbox, true is Checked and false is Unchecked
             */
            $_onExportAll(themelayer, value) {
                themelayer.informationAttributes.forEach(
                    (item) => (item.exportable = value)
                );
            },

            /**
             * Sets the property print of all informationAttributes
             * @param themelayer the active themelayer
             * @param value the value of checkbox, true is Checked and false is Unchecked
             */
            $_onPrintAll(themelayer, value) {
                themelayer.informationAttributes.forEach(
                    (item) => (item.print = value)
                );
            },

            /**
             * Removes given attribute from informationAttributes array
             * @param attribute
             */
            $_removeAttribute(attribute) {
                const data = {
                    message: this.$t('themeCardAttributeDeletionsConfirmation')
                };
                this.msgBoxConfirm(data).then((confirm) => {
                    if (confirm) {
                        this.localThemelayer.informationAttributes = without(
                            this.localThemelayer.informationAttributes,
                            attribute
                        );
                    }
                });
            },

            /**
             * Set the initial indeterminate checkbox states for detail, table and pop-up
             */
            $_setIndeterminateStates() {
                this.$_updateIntermediateState(
                    this.localThemelayer,
                    this.displayType.table
                );
                this.$_updateIntermediateState(
                    this.localThemelayer,
                    this.displayType.detail
                );
                this.$_updateIntermediateState(
                    this.localThemelayer,
                    this.displayType.popup
                );
                this.$_updateIntermediateState(
                    this.localThemelayer,
                    this.displayType.exportable
                );
                this.$_updateIntermediateState(
                    this.localThemelayer,
                    this.displayType.print
                );
            },

            /**
             * Update the display-in-detail intermediate checkbox state: true if some but not all are checked
             * display type must be either 'displayInTable', 'displayInDetail' or 'popup'
             * @param {object} themelayer - the themelayer
             * @param {string} displayType - the display type
             */
            $_updateIntermediateState(themelayer, displayType) {
                switch (displayType) {
                    case this.displayType.table:
                        this.displayInTableIntermediate =
                            this.$_getIntermediateState(themelayer, displayType);
                        if (!this.displayInTableIntermediate) {
                            this.$nextTick(function () {
                                this.allDisplayInTableChecked =
                                    this.$_getAllCheckedState(
                                        themelayer,
                                        displayType
                                    );
                            });
                        }
                        break;
                    case this.displayType.detail:
                        this.displayInDetailIntermediate =
                            this.$_getIntermediateState(themelayer, displayType);
                        if (!this.displayInDetailIntermediate) {
                            this.$nextTick(function () {
                                this.allDisplayInDetailChecked =
                                    this.$_getAllCheckedState(
                                        themelayer,
                                        displayType
                                    );
                            });
                        }
                        break;
                    case this.displayType.popup:
                        this.popupIntermediate = this.$_getIntermediateState(
                            themelayer,
                            displayType
                        );
                        if (!this.popupIntermediate) {
                            this.$nextTick(function () {
                                this.allPopupChecked = this.$_getAllCheckedState(
                                    themelayer,
                                    displayType
                                );
                            });
                        }
                        break;
                    case this.displayType.exportable:
                        this.exportableIntermediate = this.$_getIntermediateState(
                            themelayer,
                            displayType
                        );
                        if (!this.exportableIntermediate) {
                            this.$nextTick(function () {
                                this.allExportableChecked =
                                    this.$_getAllCheckedState(
                                        themelayer,
                                        displayType
                                    );
                            });
                        }
                        break;
                    case this.displayType.print:
                        this.printIntermediate = this.$_getIntermediateState(
                            themelayer,
                            displayType
                        );
                        if (!this.printIntermediate) {
                            this.$nextTick(function () {
                                this.allPrintChecked = this.$_getAllCheckedState(
                                    themelayer,
                                    displayType
                                );
                            });
                        }
                        break;
                }
            },

            $_updateOrderColumn() {
                this.localThemelayer.informationAttributes.forEach(
                    (item, index) => {
                        item.order = (index + 1) * 10;
                    }
                );
            },

            $_onClickChangeOrder() {
                this.localThemelayer.informationAttributes.sort(
                    (a, b) => a.order - b.order
                );
            },

            $_onClickMoveCheckedOnTop() {
                const checkedItems =
                    this.localThemelayer.informationAttributes.filter(
                        (item) =>
                            item.displayInDetail ||
                            item.displayInTable ||
                            item.popup
                    );
                const uncheckedItems =
                    this.localThemelayer.informationAttributes.filter(
                        (item) =>
                            !(
                                item.displayInDetail ||
                                item.displayInTable ||
                                item.popup
                            )
                    );
                this.localThemelayer.informationAttributes =
                    checkedItems.concat(uncheckedItems);
                this.$_updateOrderColumn();
            },

            $_onInputDisplayInTable(themelayer, item, displayType) {
                item.exportable = item.displayInTable ? true : item.exportable;
                this.$_updateIntermediateState(themelayer, displayType);
            }
        }
    };
</script>

<style lang="scss">
#informationoverview {
    & div .order-input {
        width: 60px;
    }
    & div .sort-select {
        width: 110px;
    }
    .form-group {
        margin-bottom: 0px;
    }
}
</style>

<style scoped lang="scss">
.table-sticky-header-container {
    height: 750px;
    margin-bottom: 25px;
    border-top: 1px solid #dee2e6;

    > div {
        height: 100%;
        overflow: auto;

        > table {
            display: initial;
            border: 0;

            th {
                position: sticky;
                top: 0;
                z-index: 2;
                background-color: white;

                &:first-child {
                    border-left: 1px solid #dee2e6;
                }
            }
        }
    }
}

.fa-arrows-alt:hover {
    cursor: move;
}

.borderless-header {
    border: 0px;
}

.order-column {
    & div {
        display: flex;
        align-items: center;

        & em {
            padding-right: 0.4rem;
        }
    }
}

#informationoverview.table-bordered {
    td {
        vertical-align: middle;
    }
    // Following classes together remove the vertical line between the last two cells in each row
    td:nth-child(11) {
        border-right-width: 0px;
    }

    td:last-child {
        border-left-width: 0px;
    }
}
</style>
